import React, { useState, useEffect, Fragment } from "react";
import { post, fetchJson } from "../../lib/Fetching";
import Button from "../Button";
import Input from "../Input";
import Select from "react-select";

export default function WithdrawSamples({ sampleIds, close, reloadData, clientView }) {
  const [withdrawalTypes, setWithdrawalTypes] = useState([]);
  const [selected, setSelected] = useState(null);
  const [comment, setComment] = useState(null);
  const [allowMultipleclients, setAllowMultipleclients] = useState(false);

  useEffect(() => {
    fetchJson("/registration/withdrawal_types", {}).then((wtypes) => {
      setWithdrawalTypes(wtypes.map((c) => ({ value: c.id, label: c.name })));
    });
  }, []);

  const valid = sampleIds.length > 0 && selected;

  const handleSubmit = () => {
    if (!valid) return;
    post("/registration/samples/withdraw", {
      sample_ids: sampleIds,
      withdrawal_type_id: selected.value,
      comment: comment,
      allow_multiple_clients: allowMultipleclients,
    })
      .then((json) => {
        console.log(json);
        if (json.errors) {
          alert(json.errors);
        } else {
          reloadData();
          close();
        }
      })
      .catch((errors) => {
        alert(errors);
      });
  };

  return (
    <div className="withdraw-samples-form">
      <h3 style={{ margin: 0, marginBottom: 10 }}>
        {I18n.t("withdraw_samples_dialog.warning", { count: sampleIds.length })}
      </h3>
      <p>
        &nbsp;&nbsp;
        {I18n.t("withdraw_samples_dialog.samples_selected", { count: sampleIds.length })}
        {sampleIds.map((id) => (
          <span style={{ marginRight: 10 }}>{id}</span>
        ))}
      </p>
      <div className="row">
        <div className="col-md-5" style={{ paddingRight: 0, textAlign: "left" }}>
          <Select
            value={selected}
            options={withdrawalTypes}
            onChange={setSelected}
            placeholder={"Please select reason"}
          />
        </div>
        <div className="col-md-4">
          <Input
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder={I18n.t("enter_comment")}
            className="form-control"
          />
        </div>
        <div className="col-md-3">
          <Button
            deleting
            disabled={!valid}
            onClick={handleSubmit}
            block
            icon="fa-trash"
            title={I18n.t("withdraw_samples")}
            primary
            style={{ height: 38 }}
          />
          {!clientView && (
            <label style={{ marginTop: 10 }}>
              <input
                type="checkbox"
                checked={allowMultipleclients}
                onChange={(e) => setAllowMultipleclients(e.target.checked)}
              />
              &nbsp; Can withdraw samples across multiple clients?
            </label>
          )}
        </div>
      </div>
      {!clientView &&
        allowMultipleclients && (
          <div className="row">
            <div className="col-md-6" />
            <div className="col-md-6">
              Rules for withdrawing samples across multiple clients:
              <ul>
                <li>All samples must have not yet been received by the laboratory</li>
                <li>You cannot select more than 100 samples</li>
              </ul>
            </div>
          </div>
        )}
    </div>
  );
}
